import { createContext, useContext, useEffect, useState } from 'react';

// Create the context
const ThemeContext = createContext({
  theme: 'dark', // default
  toggleTheme: () => {},
});

export const ThemeProvider = ({ children }) => {
  // Check local storage or default to 'dark'
  const [theme, setTheme] = useState(() => {
    const savedTheme = localStorage.getItem('app_theme');
    if (savedTheme) return savedTheme;
    return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  });

  // Whenever the theme changes, update localStorage and the body class
  useEffect(() => {
    localStorage.setItem('app_theme', theme);
    document.body.className = `theme-${theme}`;
  }, [theme]);

  const toggleTheme = () => {
    setTheme(prevTheme => (prevTheme === 'light' ? 'dark' : 'light'));
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

// Custom hook for easy access
export const useTheme = () => useContext(ThemeContext);
